// Placeholder data for report sections - will be replaced with API calls later
// Format matches the API response structure for ViolationHistorySection
export const PLACEHOLDER_REPORT_DATA = {
  violations: {
    last3yearViolations: {
      a: 24,
      b: 65,
      c: 38,
      i: 135,
    },
    unitViolations: [
      {
        unit: '4D',
        floor: 4,
        classA: [
          {
            year: 2024,
            approvedDate: '2024-05-28T00:00:00+00:00',
            currentStatus: 'INVALID CERTIFICATION',
            novDescription:
              '§ 329, M/D LAW AND DEPT. RULES AND REGS. PROVIDE A COMPLETED CERTIFICATE OF INSPECTION VISITS IN A PROPER FRAME AT OR NEAR MAILBOXES',
            violationStatus: 'Open',
          },
        ],
        classB: [],
        classC: [],
        classI: [],
      },
      {
        unit: '5E',
        floor: 5,
        classA: [
          {
            year: 2024,
            approvedDate: '2024-05-28T00:00:00+00:00',
            currentStatus: 'NOV SENT OUT',
            novDescription:
              '§ 27-2029 ADM. CODE: OWNER FAILED TO FILE A VALID REGISTRATION STATEMENT WITH THE DEPARTMENT AS REQUIRED BY ADM. CODE §27-2097 AND IS THEREFORE SUBJECT TO CIVIL PENALTIES',
            violationStatus: 'Open',
          },
          {
            year: 2023,
            approvedDate: '2023-12-15T00:00:00+00:00',
            currentStatus: 'RESOLVED',
            novDescription: '§ 27-2017.3 ADM. CODE: PAINT THE CEILING IN THE ENTIRE APARTMENT',
            violationStatus: 'Closed',
          },
        ],
        classB: [
          {
            year: 2024,
            approvedDate: '2024-03-10T00:00:00+00:00',
            currentStatus: 'NOV SENT OUT',
            novDescription:
              '§ 27-2005 ADM. CODE: REPAIR THE BROKEN OR DEFECTIVE PLASTERED SURFACES AND PAINT IN A UNIFORM COLOR',
            violationStatus: 'Open',
          },
        ],
        classC: [],
        classI: [],
      },
    ],
  },
  bedbugs: [],
  rodents: [],
  construction: {
    constructions: {
      major_construction: {
        A1: [],
        NB: [],
      },
      minor_construction: {
        A2: [],
        A3: [],
      },
    },
  },
} as const;

// Shared utility functions for rodent infestation components

export interface RodentTitleAndDescription {
  title: string;
  description: string;
}

// Get title and description based on result - shared logic for section and modal
export const getRodentTitleAndDescription = (resultValue: string): RodentTitleAndDescription => {
  if (resultValue === 'Passed') {
    return {
      title: 'No rodent activity',
      description: 'The inspector did not observe any active signs of rat and mouse activity.',
    };
  } else if (resultValue === 'Rat Activity') {
    return {
      title: 'Rodent activity detected',
      description:
        'The health department observed active signs of, or conditions conducive to, rat or mouse activity.',
    };
  } else if (resultValue === 'Failed for Other R') {
    return {
      title: 'Rodent activity detected',
      description:
        'This building failed the last rodent inspection due to exposed garbage, harborage conditions or mice.',
    };
  } else if (resultValue === 'Bait applied') {
    return {
      title: 'Bait applied',
      description: 'A health department pest professional applied treatments or baits.',
    };
  } else if (resultValue === 'Monitoring visit') {
    return {
      title: 'Monitoring visit',
      description:
        'Follow-up visits from the Health Department to monitor progress from the last failed inspections.',
    };
  } else {
    return {
      title: 'Inspection history not available',
      description: "This building's rodent inspection history is not available.",
    };
  }
};
